"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = require("prop-types");

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = require("styled-components");

var _Table = _interopRequireDefault(require("../Table.context"));

var _TableHeaderCell = require("./TableHeaderCell.styles");

var _excluded = ["children", "className"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var TableHeaderCell = function TableHeaderCell(_ref) {
  var children = _ref.children,
      className = _ref.className,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var context = (0, _react.useContext)(_Table["default"]);
  var size = context.size;
  return (
    /*#__PURE__*/
    // unicode value for &nbsp: \u00a0
    // eslint-disable-next-line react/jsx-props-no-spreading
    _react["default"].createElement(_TableHeaderCell.StyledTableHeaderCell, (0, _extends2["default"])({
      size: size
    }, props, {
      className: className
    }), children || "\xA0")
  );
};

TableHeaderCell.defaultProps = {
  children: _propTypes.node,
  className: ''
};
TableHeaderCell.propTypes = {
  /** TableHeaderCell children */
  children: _propTypes.node,

  /** Custom class to be added to the header cell container. */
  className: _propTypes.string
};
TableHeaderCell.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "TableHeaderCell",
  "props": {
    "children": {
      "defaultValue": {
        "value": "node",
        "computed": true
      },
      "description": "TableHeaderCell children",
      "type": {
        "name": "node"
      },
      "required": false
    },
    "className": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "Custom class to be added to the header cell container.",
      "type": {
        "name": "string"
      },
      "required": false
    }
  }
};

var _default = (0, _styledComponents.withTheme)(TableHeaderCell);

exports["default"] = _default;